import "./index.scss";

export function ValueWithUnit(props: { unit: string, value: number, setValue: (value: number) => void, valid: boolean }) {
    return (
        <div className={`value-with-unit flex-spacer${props.valid ? "" : " value-with-unit--invalid"}`}>
            <input min={0} value={props.value || ""} onChange={e => props.setValue(Number(e.target.value))} spellCheck={false} type="number" className="value-with-unit__input" />
            <div className="value-with-unit__unit">{props.unit}</div>
        </div>
    );
}